import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-md flex-col items-center justify-center px-4 text-center">
      <XCircle className="h-14 w-14 text-[#FFB800]" />
      <h1 className="font-display mt-6 text-2xl font-bold text-white" data-testid="payment-cancelled">Payment cancelled</h1>
      <p className="mt-2 text-slate-400">No charge was made. Your cart is still saved — you can complete checkout whenever you're ready.</p>
      <div className="mt-6 flex gap-3">
        <Button onClick={() => navigate("/checkout")} className="rounded-xl bg-[#00F0FF] text-[#08090E] hover:bg-[#33F3FF]" data-testid="cancel-back-checkout">Return to Checkout</Button>
        <Button onClick={() => navigate("/shop")} variant="outline" className="rounded-xl border-white/15 bg-transparent text-slate-100 hover:bg-white/5">Continue Shopping</Button>
      </div>
    </div>
  );
}
